import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-07190dc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapping" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "item-detail"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p class=\"ttl\" data-v-07190dc8>会社名</p><p data-v-07190dc8>株式会社クープデザイン</p><p data-v-07190dc8>Coupe Design Co., Ltd.</p><p class=\"ttl\" data-v-07190dc8>所在地</p><p data-v-07190dc8>104-0061</p><p data-v-07190dc8>東京都中央区銀座1-16-7</p><p data-v-07190dc8>銀座大栄ビル6階(受付5階)</p><p class=\"ttl\" data-v-07190dc8>電話</p><p aria-label=\"0343608675\" data-v-07190dc8>03-4360-8675</p><p class=\"ttl\" data-v-07190dc8>代表者</p><p data-v-07190dc8>代表取締役社長 保科里佳</p><p class=\"ttl\" data-v-07190dc8>設立</p><p data-v-07190dc8>2024年7月</p><p class=\"ttl\" data-v-07190dc8>取引銀行</p><p data-v-07190dc8>三菱UFJ銀行 京橋支店</p>", 15)
const _hoisted_21 = [
  _hoisted_6
]
const _hoisted_22 = {
  key: 1,
  class: "item-detail"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<p class=\"ttl\" data-v-07190dc8>Trade name</p><p data-v-07190dc8>Coupe Design Co., Ltd.</p><p data-v-07190dc8>株式会社クープデザイン</p><p class=\"ttl\" data-v-07190dc8>Office location</p><p data-v-07190dc8>Daiei Ginza Building, 6th Floor (Reception on 5th Floor),<br class=\"is-pc\" data-v-07190dc8> 1-16-7, Ginza, Chuo-ku, Tokyo, 104-0061, Japan</p><p class=\"ttl\" data-v-07190dc8>Phone</p><p data-v-07190dc8>+81-3-4360-8675</p><p class=\"ttl\" data-v-07190dc8>Representative</p><p data-v-07190dc8>Representative Director and President</p><p data-v-07190dc8>Rika Hoshina</p><p class=\"ttl\" data-v-07190dc8>Established</p><p data-v-07190dc8>July 2024</p><p class=\"ttl\" data-v-07190dc8>Customer Bank</p><p data-v-07190dc8>MUFG Bank, Ltd. Kyobashi Branch.</p>", 14)
const _hoisted_37 = [
  _hoisted_23
]


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyProfile',
  props: ['translate'],
  setup(__props) {

const props = __props 


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.translate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "会社概要"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Company Profile"))
    ]),
    (props.translate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_21))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_37))
  ]))
}
}

})